const typographyModelEquipService = {
  true: 'Register New Service',
  false: 'Edit Service',
  warningTitle: 'Service Disabled for This Type of Equipment',
  warningText: 'This service is no longer linked to this type of equipment. However, the history remains available on the linked equipment. To view it, access the desired equipment.',
};

export default typographyModelEquipService;
